import _toArray from "@babel/runtime/helpers/toArray";
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import Papa from 'papaparse';
export const normalizeName = name => name.trim().replace(/\s+/g, ' ').toLowerCase();
export const parseCsvText = text => {
  const records = Papa.parse(text, {
    delimiter: ','
  }).data.filter(row => {
    var _row$;
    return row.length > 1 || ((_row$ = row[0]) === null || _row$ === void 0 ? void 0 : _row$.trim());
  });
  const _records = _toArray(records),
    _records$ = _records[0],
    headerRow = _records$ === void 0 ? [] : _records$,
    rawRows = _arrayLikeToArray(_records).slice(1);
  return {
    headers: headerRow.map(h => h.trim()),
    rawRows,
    rows: rawRows.map(row => row.map(v => v.trim()))
  };
};
export const findHeader = (headers, name) => {
  const wanted = (name || '').trim().toLowerCase();
  const matches = wanted ? headers.filter(h => h && h.toLowerCase() === wanted) : [];
  return matches.length === 1 ? matches[0] : undefined;
};